import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import { useSelector } from 'react-redux'
import { State } from '../types/state'

const LoadingSpinnerProvider = (): JSX.Element => {
  const { isSpinnerVisible } = useSelector((state: State) => state.refresh)

  return isSpinnerVisible
    ? (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh'
        }}
      >
        <CircularProgress />
      </div>
      )
    : (
      <></>
      )
}

export default LoadingSpinnerProvider
